import { convertWixAdressToGoogleAddress, getGoogleTemplate, parseGoogleTemplate, trimGoogleTemplate, applyTemplate, } from './parser';
export const formatAddress = ({ address, addressContactDetails, }, { appendCountry = true } = {}) => {
    const googleAddressFormat = convertWixAdressToGoogleAddress(address, addressContactDetails);
    const template = getGoogleTemplate(address.country);
    const tokens = parseGoogleTemplate(template);
    const trimmedTemplate = trimGoogleTemplate(googleAddressFormat, tokens);
    return applyTemplate(googleAddressFormat, trimmedTemplate, {
        appendCountry,
    });
};
//# sourceMappingURL=formatter.js.map